import React, { useEffect, useState } from 'react'
import { resetErrorFieldStyle } from '../Variables';

const timezones = [
    { label: "Hawaii Standard Time", abbr: "HST", value: "Pacific/Honolulu", city: "Honolulu", offset: "UTC-10" },
    { label: "Hawaii-Aleutian Daylight Time", abbr: "HDT", value: "America/Adak", city: "Adak", offset: "UTC-9" },
    { label: "Alaska Daylight Time", abbr: "AKDT", value: "America/Anchorage", city: "Anchorage", offset: "UTC-8" },
    { label: "Pacific Daylight Time", abbr: "PDT", value: "America/Los_Angeles", city: "Los Angeles", offset: "UTC-7" },
    { label: "Mountain Standard Time", abbr: "MST", value: "America/Phoenix", city: "Phoenix", offset: "UTC-7" },
    { label: "Mountain Daylight Time", abbr: "MDT", value: "America/Denver", city: "Salt Lake City", offset: "UTC-6" },
    { label: "Central Daylight Time", abbr: "CDT", value: "America/Chicago", city: "Chicago", offset: "UTC-5" },
    { label: "Eastern Daylight Time", abbr: "EDT", value: "America/New_York", city: "New York", offset: "UTC-4" },
];

export const TimeZoneDropdown = ({ selectedTimezone, onChange, isBgBlack = true }) => {
    const [liveTime, setLiveTime] = useState("");

    useEffect(() => {
        const updateTime = () => {
            if (!selectedTimezone) return setLiveTime("");
            const now = selectedTimezone && new Date().toLocaleTimeString("en-US", {
                timeZone: selectedTimezone,
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            });
            setLiveTime(now);
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, [selectedTimezone]);

    return (
        <div className={`${isBgBlack ? "mb-3" : ""}`}>
            {
                isBgBlack && (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <label className="text-white form-label mb-0">Select Timezone</label>
                        {liveTime && (
                            <span className="text-white small">🕒 {liveTime}</span>
                        )}
                    </div>
                )
            }

            <select
                className={`${isBgBlack ? "bg-black border-0 text-white py-2 px-3" : ""} form-select`}
                id={`${isBgBlack ? "selected_timezone" : ""}`}
                value={selectedTimezone}
                onChange={onChange}
                onFocus={resetErrorFieldStyle}
            >
                <option className="selectedProviderOption" value="">Select Timezone</option>
                {timezones.map((tz) => (
                    <option key={tz.value} value={tz.value}>
                        {`${tz.offset} ${tz.abbr} - ${tz.city}`}
                    </option>
                ))}
            </select>
        </div>
    );
}
